export default "__VITE_ASSET__BYz6Q9Gj__"